class EnvironmentUtil {
  static getUrl() {
    const env = this.getEnvObject();
    return env.url;
  }

  static getCometUrl() {
    const env = this.getEnvObject();
    return env.cometUrl;
  }

  static getEnvObject(action = null) {
    if (action === "reset") {
      localStorage.setItem("environmentOLRTools", null);
    }

    let env = null;

    try {
      env = JSON.parse(localStorage.getItem("environmentOLRTools"));
    } catch (e) {
      localStorage.setItem("environmentOLRTools", JSON.stringify(env));
    }
    if (env !== null) {
      return env;
    }
    let envs = JSON.parse(localStorage.getItem("environmentsOLRTools"));
    if (envs === null) {
      localStorage.setItem(
        "environmentsOLRTools",
        JSON.stringify([
          {
            name: "Development",
            env: "development",
            domain: "api-dev.fastlaneams.com",
            // url: "https://api-dev.fastlaneams.com",
            url: "http://ec2-34-200-98-24.compute-1.amazonaws.com/api",
            path: "",
          },
        ])
      );
      envs = JSON.parse(localStorage.getItem("environmentOLRTools"));
    }

    const hostname = window.location.hostname;
    const fullPath = window.location.pathname;
    const path = fullPath.substring(0, fullPath.lastIndexOf("/"));

    if (envs !== null && envs.length > 0) {
      if (hostname === "localhost") {
        env = envs.find((obj) => obj.env === "development");
      } else {
        env = envs.find((obj) => obj.env === "development");
      }

      if (env !== null) {
        env.path = path;
        localStorage.setItem("environmentOLRTools", JSON.stringify(env));
        return env;
      }
    }
    return null;
  }
}

export { EnvironmentUtil as default };
